import { startAuthentication, startRegistration } from '@simplewebauthn/browser';

import { config } from '@brands/config/config';

import { client } from '../client';

export interface VerifyTokensResponse {
  access_token: string;
  refresh_token: string;
  role?: string;
}

export interface PasskeySummary {
  id: number;
  credential_id: string;
  nickname: string | null;
  created_at: string | null;
  last_used_at: string | null;
}

// Enroll a passkey (caller must be authenticated; bearer token is attached
// automatically by the axios client interceptor).
export const registerPasskey = async (nickname?: string): Promise<void> => {
  const { data: begin } = await client.post('/auth/webauthn/register/begin');
  const attResp = await startRegistration({ optionsJSON: begin.options });
  await client.post('/auth/webauthn/register/verify', {
    credential: attResp,
    state: begin.state,
    nickname,
  });
};

// Usernameless sign-in. Resolves to JWT tokens on success.
export const authenticatePasskey = async (): Promise<VerifyTokensResponse> => {
  const { data: begin } = await client.post('/auth/webauthn/authenticate/begin');
  const authResp = await startAuthentication({ optionsJSON: begin.options });
  const { data } = await client.post<VerifyTokensResponse>(
    '/auth/webauthn/authenticate/verify',
    { credential: authResp, state: begin.state, organization_id: config.organization_id },
  );
  return data;
};

export const listPasskeys = async (): Promise<PasskeySummary[]> => {
  const { data } = await client.get('/auth/webauthn/credentials');
  return data.credentials;
};

export const deletePasskey = async (id: number): Promise<void> => {
  await client.delete(`/auth/webauthn/credentials/${id}`);
};
